import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from './config';

function CalendarPersonalPMM (props)
{
    useEffect(() => {
        // Ajax call to http://paymemobile.fr:443/hdinhthinh and get JSON
        axios.get(API_URL + '/hdinhthinh')
            .then(response => {
                console.log(response.data);
            }
        );
    }, []);

    return(
        <></>
    )
}

export default CalendarPersonalPMM